import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4d2c5152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "A quién seguir", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Top 10 Usuarios Con Mayor Reputación", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "modern-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Imagen"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre (Reputación)"),
    /*#__PURE__*/_createElementVNode("th", null, "Acciones")
  ])
], -1))
const _hoisted_10 = { style: {"width":"60px","height":"60px"} }
const _hoisted_11 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Top 5 Usuarios Con Más Shorts", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_15 = { class: "table-container" }
const _hoisted_16 = { class: "modern-table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Imagen"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Acciones")
  ])
], -1))
const _hoisted_18 = { style: {"width":"60px","height":"60px"} }
const _hoisted_19 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Top 5 Usuarios Con Más Posts", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_23 = { class: "table-container" }
const _hoisted_24 = { class: "modern-table" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Imagen"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Acciones")
  ])
], -1))
const _hoisted_26 = { style: {"width":"60px","height":"60px"} }
const _hoisted_27 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Top 5 Usuarios Que Han Publicado Más CodeBites Este Mes", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_31 = { class: "table-container" }
const _hoisted_32 = { class: "modern-table" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Imagen"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Acciones")
  ])
], -1))
const _hoisted_34 = { style: {"width":"60px","height":"60px"} }
const _hoisted_35 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Top 5 Usuarios Que Han Publicado Más CodePosts Este Mes", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_39 = { class: "table-container" }
const _hoisted_40 = { class: "modern-table" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Imagen"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Acciones")
  ])
], -1))
const _hoisted_42 = { style: {"width":"60px","height":"60px"} }
const _hoisted_43 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Buscar Usuario Por Nombre", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_47 = { class: "search-form" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_49 = { class: "table-container" }
const _hoisted_50 = { class: "modern-table" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Imagen"),
    /*#__PURE__*/_createElementVNode("th", null, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", null, "Acciones")
  ])
], -1))
const _hoisted_52 = { style: {"width":"60px","height":"60px"} }
const _hoisted_53 = { style: {"display":"flex","align-items":"center"} }

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ChannelService from '@/services/ChannelService'
import { onMounted, ref, Ref } from 'vue';
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router';
import FollowChannelButton from '@/components/widgets/FollowChannelButton.vue';
import SocialProfileImage from '@/components/widgets/SocialProfileImage.vue';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchChannelsView',
  setup(__props) {

const service = new ChannelService()
const filtered:Ref<any> = ref([])
const loading = ref(true)
const search = ref('')
const toast = useToast()
const mostReputated = ref()
const mostActive = ref()
const mostActiveMonth = ref()
const mostActiveCodePosts = ref()
const mostActiveCodePostsMonth = ref()


onMounted(async () => {
    loading.value = true
    mostReputated.value = await service.GetMostReputatedChannels()
    mostActive.value = await service.GetMostActiveChannels()
    mostActiveCodePosts.value = await service.GetMostActiveChannelsCodePost()
    mostActiveMonth.value = await service.GetMostActiveChannelsMonth()
    mostActiveCodePostsMonth.value = await service.GetMostActiveChannelsCodePostMonth()
   // items.value = await service.ListFollowers(user.value.id)
   // filtered.value = items.value
    loading.value = false
})
const goBack = () => {
    router.back()
}
const readMore = (id:number) => {
    router.push({name: 'social-profile', params: {id: id}})
}


const handleSearch = async () => {
    if(search.value.length < 3) {
        toast.showToast("La longitud mínima es de 3 caracteres.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    filtered.value = await service.SearchByName(search.value)
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
              class: "new-question",
              onClick: goBack
            }, "Volver Atrás"),
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mostReputated.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(SocialProfileImage, { user: item }, null, 8, ["user"])
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(index+1) + ". " + _toDisplayString(item.name) + " (" + _toDisplayString(item.reputation.toLocaleString()) + ")", 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_icon, {
                            name: "md-fileopen-round",
                            class: "ver",
                            fill: _unref(main).SECONDARY_COLOR,
                            scale: "2",
                            onClick: ($event: any) => (readMore(item.id))
                          }, null, 8, ["fill", "onClick"]),
                          _createVNode(FollowChannelButton, {
                            user_id: item.id
                          }, null, 8, ["user_id"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mostActive.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(SocialProfileImage, { user: item }, null, 8, ["user"])
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(index+1) + ". " + _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_v_icon, {
                            name: "md-fileopen-round",
                            class: "ver",
                            fill: _unref(main).SECONDARY_COLOR,
                            scale: "2",
                            onClick: ($event: any) => (readMore(item.id))
                          }, null, 8, ["fill", "onClick"]),
                          _createVNode(FollowChannelButton, {
                            user_id: item.id
                          }, null, 8, ["user_id"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_20,
            _hoisted_21,
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("table", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mostActiveCodePosts.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(SocialProfileImage, { user: item }, null, 8, ["user"])
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(index+1) + ". " + _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_v_icon, {
                            name: "md-fileopen-round",
                            class: "ver",
                            fill: _unref(main).SECONDARY_COLOR,
                            scale: "2",
                            onClick: ($event: any) => (readMore(item.id))
                          }, null, 8, ["fill", "onClick"]),
                          _createVNode(FollowChannelButton, {
                            user_id: item.id
                          }, null, 8, ["user_id"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("table", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mostActiveMonth.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(SocialProfileImage, { user: item }, null, 8, ["user"])
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(index+1) + ". " + _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_v_icon, {
                            name: "md-fileopen-round",
                            class: "ver",
                            fill: _unref(main).SECONDARY_COLOR,
                            scale: "2",
                            onClick: ($event: any) => (readMore(item.id))
                          }, null, 8, ["fill", "onClick"]),
                          _createVNode(FollowChannelButton, {
                            user_id: item.id
                          }, null, 8, ["user_id"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_36,
            _hoisted_37,
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("table", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mostActiveCodePostsMonth.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(SocialProfileImage, { user: item }, null, 8, ["user"])
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(index+1) + ". " + _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_v_icon, {
                            name: "md-fileopen-round",
                            class: "ver",
                            fill: _unref(main).SECONDARY_COLOR,
                            scale: "2",
                            onClick: ($event: any) => (readMore(item.id))
                          }, null, 8, ["fill", "onClick"]),
                          _createVNode(FollowChannelButton, {
                            user_id: item.id
                          }, null, 8, ["user_id"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_44,
            _hoisted_45,
            _hoisted_46,
            _createElementVNode("form", _hoisted_47, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                placeholder: "Escribe aquí para buscar por nombre",
                class: "input-job"
              }, null, 512), [
                [_vModelText, search.value]
              ]),
              _createElementVNode("button", {
                class: "search-btn",
                onClick: _withModifiers(handleSearch, ["prevent"])
              }, "Buscar")
            ]),
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("table", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(SocialProfileImage, { user: item }, null, 8, ["user"])
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_v_icon, {
                            name: "md-fileopen-round",
                            class: "ver",
                            fill: _unref(main).SECONDARY_COLOR,
                            scale: "2",
                            onClick: ($event: any) => (readMore(item.id))
                          }, null, 8, ["fill", "onClick"]),
                          _createVNode(FollowChannelButton, {
                            user_id: item.id
                          }, null, 8, ["user_id"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})